import { gql } from '@urql/core';

export const ACCEPT_TERMS_AND_CONDITIONS = gql`
  mutation {
    acceptTermsAndConditions {
      status
      message
    }
  }
`;

export const GENERATE_TERMS_AND_CONDITIONS = gql`
  mutation {
    generateCombinedProcessingAgreement {
      message
      status
      record {
        id
        name
        downloadable_for_advisor
        created_at
        updated_at
        asset {
          id
          filename
          extension
          absolute_url
          created_at
          updated_at
          filesize {
            human
            raw
          }
        }
      }
    }
  }
`;
